import {
  getPathnameByUrl,
  notProtectedRoutes,
  subPermissionRoutes,
  UserPermissionRoutes,
} from "@/constant/constants";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

function isUserAllowed(user, roleByPath, subPermission) {
  if (user?.role === "super-admin") {
    return true;
  }
  const permissions = user?.roleGroup?.permissions;
  if (notProtectedRoutes?.includes(roleByPath)) {
    return true;
  }
  const permission = permissions?.find(
    (perm) => perm?.main === UserPermissionRoutes[roleByPath]
  );
  if (!permission) return false;

  if (!subPermission) return true;

  if (subPermissionRoutes[subPermission]) {
    return permissions?.find(
      (perm) =>
        perm?.main === UserPermissionRoutes[roleByPath] &&
        perm?.sub?.includes(subPermissionRoutes[subPermission])
    );
  }
  return false;
}

function ProtectedRouter({ element: Element, isProtected }) {
  const { isLogin, user } = useSelector((state) => state.authReducer);
  // const isAuthenticated = true;

  const pathname = useLocation().pathname;
  const [roleByPath, subPermission] = getPathnameByUrl(pathname);

  // If route is not protected and user is not logged in, redirect to login
  if (!isProtected && !isLogin) {
    return Element;
  }

  // If route is not protected and user is logged in, redirect to dashboard
  if (!isProtected && isLogin) {
    return <Navigate replace to="/" />;
  }

  // If route is protected but user is not logged in, redirect to login
  if (isProtected && !isLogin) {
    return <Navigate replace to="/login" />;
  }

  // If user is logged in, check permissions
  const isAllowed = isUserAllowed(user, roleByPath, subPermission);

  // if (isAuthenticated && !isProtected) {
  //   return <Navigate replace to="/" />;
  // }

  return isAllowed ? Element : <Navigate replace to="/" />;
}
export default ProtectedRouter;
